// Dummy data for all dashboard pages. Key = route slug (last path segment).

export const dummyTables = {
  listsubadmin: {
    columns: [
      { key: "name", label: "Name" },
      { key: "email", label: "Email" },
      { key: "role", label: "Role" },
      { key: "status", label: "Status" },
      { key: "created", label: "Created" },
    ],
    rows: [
      { name: "John Doe", email: "john@example.com", role: "Support", status: "Active", created: "2025-01-15" },
      { name: "Jane Smith", email: "jane@example.com", role: "KYC", status: "Active", created: "2025-01-10" },
      { name: "Mike Wilson", email: "mike@example.com", role: "Finance", status: "Inactive", created: "2024-12-20" },
      { name: "Sarah Lee", email: "sarah@example.com", role: "Support", status: "Active", created: "2025-02-01" },
      { name: "Alex Brown", email: "alex@example.com", role: "Trading", status: "Active", created: "2024-11-05" },
    ],
  },
  tradelist: {
    columns: [
      { key: "emailId", label: "Email" },
      { key: "mobileNumber", label: "Mobile" },
      { key: "name", label: "Name" },
      { key: "uuid", label: "UUID" },
      { key: "status", label: "Status" },
      { key: "kycLabel", label: "KYC" },
      { key: "referral_code", label: "Referral Code" },
      { key: "createdLabel", label: "Created" },
    ],
    rows: [], // use dummyTraderList mapped in TradersListPage
  },
  pendingkyc: {
    columns: [
      { key: "user", label: "User" },
      { key: "document", label: "Document Type" },
      { key: "status", label: "Status" },
      { key: "submitted", label: "Submitted" },
      { key: "actions", label: "Actions" },
    ],
    rows: [], // use dummyKycList in KYCManagementPage
  },
  coinListDetails: {
    columns: [
      { key: "coin", label: "Coin" },
      { key: "symbol", label: "Symbol" },
      { key: "price", label: "Price (USD)" },
      { key: "change24h", label: "24h Change" },
      { key: "status", label: "Status" },
    ],
    rows: [
      { coin: "Bitcoin", symbol: "BTC", price: "43,250.00", change24h: "+2.4%", status: "Active" },
      { coin: "Ethereum", symbol: "ETH", price: "2,280.50", change24h: "-0.8%", status: "Active" },
      { coin: "BNB", symbol: "BNB", price: "315.20", change24h: "+1.2%", status: "Active" },
      { coin: "Solana", symbol: "SOL", price: "98.75", change24h: "+5.1%", status: "Active" },
      { coin: "XRP", symbol: "XRP", price: "0.52", change24h: "-1.3%", status: "Active" },
    ],
  },
  currencymanagement: {
    columns: [
      { key: "currency", label: "Currency" },
      { key: "code", label: "Code" },
      { key: "minDeposit", label: "Min Deposit" },
      { key: "status", label: "Status" },
    ],
    rows: [
      { currency: "US Dollar", code: "USD", minDeposit: "10", status: "Active" },
      { currency: "Euro", code: "EUR", minDeposit: "10", status: "Active" },
      { currency: "Indian Rupee", code: "INR", minDeposit: "500", status: "Active" },
      { currency: "British Pound", code: "GBP", minDeposit: "8", status: "Active" },
      { currency: "Japanese Yen", code: "JPY", minDeposit: "1000", status: "Inactive" },
    ],
  },
  currencypair: {
    columns: [
      { key: "pair", label: "Pair" },
      { key: "base", label: "Base" },
      { key: "quote", label: "Quote" },
      { key: "minOrder", label: "Min Order" },
      { key: "status", label: "Status" },
    ],
    rows: [
      { pair: "BTC/USDT", base: "BTC", quote: "USDT", minOrder: "0.0001", status: "Active" },
      { pair: "ETH/USDT", base: "ETH", quote: "USDT", minOrder: "0.001", status: "Active" },
      { pair: "BNB/USDT", base: "BNB", quote: "USDT", minOrder: "0.01", status: "Active" },
      { pair: "SOL/USDT", base: "SOL", quote: "USDT", minOrder: "0.1", status: "Active" },
      { pair: "XRP/USDT", base: "XRP", quote: "USDT", minOrder: "10", status: "Active" },
    ],
  },
  spotMarketTrades: {
    columns: [
      { key: "time", label: "Time" },
      { key: "pair", label: "Pair" },
      { key: "side", label: "Side" },
      { key: "amount", label: "Amount" },
      { key: "price", label: "Price" },
      { key: "fee", label: "Fee" },
    ],
    rows: [
      { time: "10:45:22", pair: "BTC/USDT", side: "Buy", amount: "0.5", price: "43,250", fee: "0.108" },
      { time: "10:44:18", pair: "ETH/USDT", side: "Sell", amount: "2.0", price: "2,280", fee: "0.091" },
      { time: "10:43:55", pair: "BNB/USDT", side: "Buy", amount: "10", price: "315", fee: "0.031" },
      { time: "10:42:10", pair: "BTC/USDT", side: "Sell", amount: "0.25", price: "43,248", fee: "0.054" },
      { time: "10:41:02", pair: "SOL/USDT", side: "Buy", amount: "50", price: "98.75", fee: "0.049" },
    ],
  },
  OrderBook: {
    type: "orderbook",
    bids: [
      { price: "43,248.00", amount: "1.250", total: "54,060.00" },
      { price: "43,247.50", amount: "0.800", total: "34,598.00" },
      { price: "43,246.00", amount: "2.100", total: "90,816.60" },
      { price: "43,245.00", amount: "0.500", total: "21,622.50" },
      { price: "43,240.00", amount: "3.000", total: "129,720.00" },
    ],
    asks: [
      { price: "43,252.00", amount: "0.900", total: "38,926.80" },
      { price: "43,255.00", amount: "1.200", total: "51,906.00" },
      { price: "43,258.00", amount: "0.750", total: "32,443.50" },
      { price: "43,260.00", amount: "2.000", total: "86,520.00" },
      { price: "43,265.00", amount: "1.500", total: "64,897.50" },
    ],
  },
  allOpenOrders: {
    columns: [
      { key: "user", label: "User" },
      { key: "pair", label: "Pair" },
      { key: "type", label: "Type" },
      { key: "price", label: "Price" },
      { key: "amount", label: "Amount" },
      { key: "status", label: "Status" },
    ],
    rows: [
      { user: "U1001", pair: "BTC/USDT", type: "Limit Buy", price: "43,000", amount: "0.5", status: "Open" },
      { user: "U1002", pair: "ETH/USDT", type: "Limit Sell", price: "2,300", amount: "2.0", status: "Open" },
      { user: "U1003", pair: "BTC/USDT", type: "Limit Buy", price: "42,500", amount: "0.25", status: "Open" },
      { user: "U1004", pair: "SOL/USDT", type: "Limit Sell", price: "100", amount: "100", status: "Open" },
      { user: "U1005", pair: "BNB/USDT", type: "Limit Buy", price: "310", amount: "5", status: "Open" },
    ],
  },
  fundsDManagement: {
    columns: [
      { key: "user", label: "User" },
      { key: "amount", label: "Amount" },
      { key: "currency", label: "Currency" },
      { key: "txid", label: "TxID" },
      { key: "status", label: "Status" },
      { key: "date", label: "Date" },
    ],
    rows: [
      { user: "user_201", amount: "1.5", currency: "BTC", txid: "0x7a3f...", status: "Pending", date: "2025-02-11" },
      { user: "user_202", amount: "500", currency: "USDT", txid: "TRC20...", status: "Completed", date: "2025-02-11" },
      { user: "user_203", amount: "10", currency: "ETH", txid: "0x9b2e...", status: "Pending", date: "2025-02-10" },
      { user: "user_204", amount: "2000", currency: "USDT", txid: "ERC20...", status: "Completed", date: "2025-02-10" },
      { user: "user_205", amount: "0.5", currency: "BTC", txid: "0x1c4d...", status: "Pending", date: "2025-02-09" },
    ],
  },
  transferTransactions: {
    columns: [
      { key: "from", label: "From" },
      { key: "to", label: "To" },
      { key: "amount", label: "Amount" },
      { key: "currency", label: "Currency" },
      { key: "date", label: "Date" },
    ],
    rows: [
      { from: "user_301", to: "user_302", amount: "100", currency: "USDT", date: "2025-02-11 09:22" },
      { from: "user_303", to: "user_304", amount: "0.01", currency: "BTC", date: "2025-02-11 08:15" },
      { from: "user_305", to: "user_301", amount: "500", currency: "USDT", date: "2025-02-10 16:40" },
      { from: "user_302", to: "user_303", amount: "2.5", currency: "ETH", date: "2025-02-10 14:00" },
      { from: "user_304", to: "user_305", amount: "50", currency: "USDT", date: "2025-02-09 11:30" },
    ],
  },
  fundsWithdrawalManagement: {
    columns: [
      { key: "user", label: "User" },
      { key: "amount", label: "Amount" },
      { key: "address", label: "Address" },
      { key: "status", label: "Status" },
      { key: "date", label: "Date" },
    ],
    rows: [
      { user: "user_401", amount: "0.2 BTC", address: "bc1q...xyz", status: "Pending", date: "2025-02-11" },
      { user: "user_402", amount: "1000 USDT", address: "TXYZ...", status: "Processing", date: "2025-02-11" },
      { user: "user_403", amount: "5 ETH", address: "0x8f2a...", status: "Completed", date: "2025-02-10" },
      { user: "user_404", amount: "0.1 BTC", address: "bc1q...abc", status: "Pending", date: "2025-02-10" },
      { user: "user_405", amount: "500 USDT", address: "TABC...", status: "Rejected", date: "2025-02-09" },
    ],
  },
  TradingCommision: {
    columns: [
      { key: "level", label: "Level" },
      { key: "maker", label: "Maker %" },
      { key: "taker", label: "Taker %" },
      { key: "volume", label: "30d Volume (BTC)" },
    ],
    rows: [
      { level: "1", maker: "0.10%", taker: "0.10%", volume: "0 - 50" },
      { level: "2", maker: "0.08%", taker: "0.09%", volume: "50 - 200" },
      { level: "3", maker: "0.06%", taker: "0.08%", volume: "200 - 500" },
      { level: "4", maker: "0.04%", taker: "0.06%", volume: "500 - 1000" },
      { level: "5", maker: "0.02%", taker: "0.04%", volume: "1000+" },
    ],
  },
  WithdrawalFees: {
    columns: [
      { key: "coin", label: "Coin" },
      { key: "fee", label: "Fee" },
      { key: "minWithdrawal", label: "Min Withdrawal" },
      { key: "network", label: "Network" },
    ],
    rows: [
      { coin: "BTC", fee: "0.0005", minWithdrawal: "0.001", network: "Bitcoin" },
      { coin: "ETH", fee: "0.005", minWithdrawal: "0.01", network: "ERC20" },
      { coin: "USDT", fee: "1", minWithdrawal: "10", network: "TRC20" },
      { coin: "BNB", fee: "0.0005", minWithdrawal: "0.02", network: "BEP20" },
      { coin: "SOL", fee: "0.01", minWithdrawal: "0.1", network: "Solana" },
    ],
  },
  exchangeWalletManagement: {
    columns: [
      { key: "coin", label: "Coin" },
      { key: "balance", label: "Balance" },
      { key: "reserved", label: "Reserved" },
      { key: "available", label: "Available" },
    ],
    rows: [
      { coin: "BTC", balance: "125.50", reserved: "12.00", available: "113.50" },
      { coin: "ETH", balance: "1,240.00", reserved: "80.00", available: "1,160.00" },
      { coin: "USDT", balance: "5,250,000", reserved: "500,000", available: "4,750,000" },
      { coin: "BNB", balance: "3,800", reserved: "200", available: "3,600" },
      { coin: "SOL", balance: "25,000", reserved: "2,000", available: "23,000" },
    ],
  },
  LaunchpadManagement: {
    columns: [
      { key: "project", label: "Project" },
      { key: "token", label: "Token" },
      { key: "progress", label: "Progress" },
      { key: "status", label: "Status" },
      { key: "endDate", label: "End Date" },
    ],
    rows: [
      { project: "Alpha Launch", token: "ALPHA", progress: "75%", status: "Live", endDate: "2025-03-01" },
      { project: "Beta Token", token: "BETA", progress: "100%", status: "Ended", endDate: "2025-02-05" },
      { project: "Gamma Finance", token: "GAMMA", progress: "30%", status: "Upcoming", endDate: "2025-03-15" },
      { project: "Delta Chain", token: "DELTA", progress: "50%", status: "Live", endDate: "2025-02-28" },
      { project: "Epsilon Labs", token: "EPS", progress: "0%", status: "Upcoming", endDate: "2025-04-01" },
    ],
  },
  AdminDebitCreditTrans: {
    columns: [
      { key: "user", label: "User" },
      { key: "type", label: "Type" },
      { key: "amount", label: "Amount" },
      { key: "ref", label: "Reference" },
      { key: "date", label: "Date" },
    ],
    rows: [
      { user: "user_501", type: "Credit", amount: "+100 USDT", ref: "REF-001", date: "2025-02-11" },
      { user: "user_502", type: "Debit", amount: "-50 USDT", ref: "REF-002", date: "2025-02-11" },
      { user: "user_503", type: "Credit", amount: "+0.01 BTC", ref: "REF-003", date: "2025-02-10" },
      { user: "user_504", type: "Debit", amount: "-200 USDT", ref: "REF-004", date: "2025-02-10" },
      { user: "user_505", type: "Credit", amount: "+5 ETH", ref: "REF-005", date: "2025-02-09" },
    ],
  },
  AnnouncementDetails: {
    type: "list",
    items: [
      { title: "System maintenance on Feb 15", date: "2025-02-10", status: "Published", id: 1 },
      { title: "New trading pair: SOL/USDT", date: "2025-02-08", status: "Published", id: 2 },
      { title: "KYC verification delay notice", date: "2025-02-05", status: "Published", id: 3 },
      { title: "Upcoming P2P feature update", date: "2025-02-01", status: "Draft", id: 4 },
      { title: "Holiday support hours", date: "2025-01-28", status: "Published", id: 5 },
    ],
  },
  "p2p-orders": {
    columns: [
      { key: "orderId", label: "Order ID" },
      { key: "buyer", label: "Buyer" },
      { key: "seller", label: "Seller" },
      { key: "amount", label: "Amount" },
      { key: "price", label: "Price" },
      { key: "status", label: "Status" },
    ],
    rows: [
      { orderId: "P2P-1001", buyer: "user_a", seller: "user_b", amount: "500 USDT", price: "82.50 INR", status: "Completed" },
      { orderId: "P2P-1002", buyer: "user_c", seller: "user_d", amount: "1000 USDT", price: "83.00 INR", status: "In Progress" },
      { orderId: "P2P-1003", buyer: "user_e", seller: "user_a", amount: "250 USDT", price: "82.80 INR", status: "Pending" },
      { orderId: "P2P-1004", buyer: "user_b", seller: "user_c", amount: "750 USDT", price: "83.20 INR", status: "Completed" },
      { orderId: "P2P-1005", buyer: "user_d", seller: "user_e", amount: "200 USDT", price: "82.00 INR", status: "Disputed" },
    ],
  },
  "p2p-ads": {
    columns: [
      { key: "adId", label: "Ad ID" },
      { key: "user", label: "User" },
      { key: "type", label: "Type" },
      { key: "price", label: "Price" },
      { key: "limit", label: "Limit" },
      { key: "status", label: "Status" },
    ],
    rows: [
      { adId: "AD-501", user: "user_x", type: "Sell", price: "82.50 INR", limit: "10,000 - 50,000", status: "Active" },
      { adId: "AD-502", user: "user_y", type: "Buy", price: "82.00 INR", limit: "5,000 - 25,000", status: "Active" },
      { adId: "AD-503", user: "user_z", type: "Sell", price: "83.00 INR", limit: "1,000 - 10,000", status: "Paused" },
      { adId: "AD-504", user: "user_x", type: "Buy", price: "81.80 INR", limit: "20,000 - 100,000", status: "Active" },
      { adId: "AD-505", user: "user_y", type: "Sell", price: "82.80 INR", limit: "15,000 - 75,000", status: "Active" },
    ],
  },
  dispute_management: {
    columns: [
      { key: "disputeId", label: "Dispute ID" },
      { key: "orderId", label: "Order ID" },
      { key: "parties", label: "Parties" },
      { key: "amount", label: "Amount" },
      { key: "status", label: "Status" },
      { key: "date", label: "Opened" },
    ],
    rows: [
      { disputeId: "D-201", orderId: "P2P-1005", parties: "user_d vs user_e", amount: "200 USDT", status: "Under Review", date: "2025-02-11" },
      { disputeId: "D-200", orderId: "P2P-0998", parties: "user_a vs user_b", amount: "1,000 USDT", status: "Resolved", date: "2025-02-08" },
      { disputeId: "D-199", orderId: "P2P-0995", parties: "user_c vs user_d", amount: "500 USDT", status: "Resolved", date: "2025-02-05" },
    ],
  },
  "p2p-fiat-management": {
    columns: [
      { key: "currency", label: "Currency" },
      { key: "code", label: "Code" },
      { key: "symbol", label: "Symbol" },
      { key: "status", label: "Status" },
    ],
    rows: [
      { currency: "Indian Rupee", code: "INR", symbol: "₹", status: "Active" },
      { currency: "US Dollar", code: "USD", symbol: "$", status: "Active" },
      { currency: "Euro", code: "EUR", symbol: "€", status: "Active" },
      { currency: "British Pound", code: "GBP", symbol: "£", status: "Active" },
      { currency: "UAE Dirham", code: "AED", symbol: "د.إ", status: "Active" },
    ],
  },
  "p2p-user-payment-methods": {
    columns: [
      { key: "user", label: "User" },
      { key: "method", label: "Method" },
      { key: "details", label: "Details" },
      { key: "status", label: "Status" },
    ],
    rows: [
      { user: "user_601", method: "Bank Transfer", details: "HDFC ****1234", status: "Verified" },
      { user: "user_602", method: "UPI", details: "user@paytm", status: "Verified" },
      { user: "user_603", method: "Bank Transfer", details: "ICICI ****5678", status: "Pending" },
      { user: "user_604", method: "PayPal", details: "user@example.com", status: "Verified" },
      { user: "user_605", method: "UPI", details: "9876543210@okaxis", status: "Verified" },
    ],
  },
  notification: {
    type: "list",
    items: [
      { title: "New KYC submission", message: "User user_102 submitted documents for verification.", date: "2025-02-11 10:30", read: false, id: 1 },
      { title: "Withdrawal completed", message: "Withdrawal of 0.5 BTC to bc1q... completed.", date: "2025-02-11 09:15", read: true, id: 2 },
      { title: "Support ticket #1042", message: "New ticket: Login issue from user_205.", date: "2025-02-10 16:45", read: false, id: 3 },
      { title: "High volume alert", message: "BTC/USDT 24h volume exceeded $1M.", date: "2025-02-10 14:00", read: true, id: 4 },
      { title: "P2P dispute opened", message: "Dispute D-201 opened for order P2P-1005.", date: "2025-02-11 11:00", read: false, id: 5 },
    ],
  },
  support: {
    columns: [
      { key: "ticketId", label: "Ticket ID" },
      { key: "user", label: "User" },
      { key: "subject", label: "Subject" },
      { key: "priority", label: "Priority" },
      { key: "status", label: "Status" },
      { key: "date", label: "Created" },
    ],
    rows: [
      { ticketId: "#1042", user: "user_701", subject: "Login issue", priority: "High", status: "Open", date: "2025-02-11" },
      { ticketId: "#1041", user: "user_702", subject: "Withdrawal delay", priority: "Medium", status: "In Progress", date: "2025-02-10" },
      { ticketId: "#1040", user: "user_703", subject: "KYC status", priority: "Low", status: "Resolved", date: "2025-02-10" },
      { ticketId: "#1039", user: "user_704", subject: "2FA reset", priority: "High", status: "Resolved", date: "2025-02-09" },
      { ticketId: "#1038", user: "user_705", subject: "Account verification", priority: "Medium", status: "Open", date: "2025-02-09" },
    ],
  },
  UpdateApk: {
    columns: [
      { key: "version", label: "Version" },
      { key: "forceUpdate", label: "Force Update" },
      { key: "releaseDate", label: "Release Date" },
      { key: "downloads", label: "Downloads" },
      { key: "status", label: "Status" },
    ],
    rows: [
      { version: "2.1.0", forceUpdate: "No", releaseDate: "2025-02-10", downloads: "12,450", status: "Live" },
      { version: "2.0.5", forceUpdate: "Yes", releaseDate: "2025-01-25", downloads: "45,200", status: "Deprecated" },
      { version: "2.1.1", forceUpdate: "No", releaseDate: "2025-02-15", downloads: "-", status: "Scheduled" },
    ],
  },
};

// Homepage: recent activity
export const recentActivity = [
  { action: "KYC submitted", user: "user_102", time: "10:30 AM" },
  { action: "Withdrawal completed", user: "user_403", time: "09:15 AM" },
  { action: "New support ticket #1042", user: "user_701", time: "Yesterday" },
  { action: "Deposit received", user: "user_202", time: "Yesterday" },
  { action: "P2P order completed", user: "user_a", time: "Feb 9" },
];

// Dashboard homepage: exchange metrics (8 cards) and login activity
export const dashboardMetrics = [
  { label: "Total Users", value: "1,248", icon: "fa-users", color: "#0d9488" },
  { label: "Pending KYC", value: "12", icon: "fa-id-card", color: "#dc2626" },
  { label: "Total Deposit (24h)", value: "₹2.4L", icon: "fa-arrow-down", color: "#16a34a" },
  { label: "Total Withdrawal (24h)", value: "₹1.1L", icon: "fa-arrow-up", color: "#0d9488" },
  { label: "Active Trading Pairs", value: "45", icon: "fa-chart-line", color: "#6366f1" },
  { label: "24h Trading Volume", value: "₹8.2Cr", icon: "fa-coins", color: "#ea580c" },
  { label: "Trading Fee (24h)", value: "₹18.5K", icon: "fa-percent", color: "#7c3aed" },
  { label: "Open Orders", value: "342", icon: "fa-list", color: "#16a34a" },
];

// KYC Management: list with status Pending | Approved | Rejected
export const dummyKycList = [
  { id: "kyc_1", user: "user_101", document: "Passport", status: "Pending", submitted: "2025-02-10", remark: "" },
  { id: "kyc_2", user: "user_102", document: "National ID", status: "Pending", submitted: "2025-02-09", remark: "" },
  { id: "kyc_3", user: "user_103", document: "Passport", status: "Approved", submitted: "2025-02-08", remark: "" },
  { id: "kyc_4", user: "user_104", document: "Driving License", status: "Pending", submitted: "2025-02-10", remark: "" },
  { id: "kyc_5", user: "user_105", document: "National ID", status: "Rejected", submitted: "2025-02-07", remark: "Document unclear" },
  { id: "kyc_6", user: "user_106", document: "Passport", status: "Approved", submitted: "2025-02-06", remark: "" },
  { id: "kyc_7", user: "user_107", document: "Aadhaar", status: "Rejected", submitted: "2025-02-05", remark: "Expired" },
  { id: "kyc_8", user: "user_108", document: "Passport", status: "Pending", submitted: "2025-02-11", remark: "" },
  { id: "kyc_9", user: "user_109", document: "Voter ID", status: "Approved", submitted: "2025-02-04", remark: "" },
  { id: "kyc_10", user: "user_110", document: "National ID", status: "Rejected", submitted: "2025-02-03", remark: "Invalid" },
];

export const loginActivity = [
  { sr: 1, activity: "Admin Login", ip: "127.0.0.1", dateTime: "2/10/2026, 3:56:59 PM" },
  { sr: 2, activity: "Admin Login", ip: "127.0.0.1", dateTime: "2/10/2026, 11:48:47 AM" },
  { sr: 3, activity: "Admin Login", ip: "192.168.1.1", dateTime: "2/9/2026, 4:22:10 PM" },
  { sr: 4, activity: "Admin Login", ip: "127.0.0.1", dateTime: "2/9/2026, 10:15:33 AM" },
  { sr: 5, activity: "Admin Login", ip: "127.0.0.1", dateTime: "2/8/2026, 2:45:00 PM" },
];

// Traders List: raw trader data
export const dummyTraderList = [
  {
    _id: "usr_001",
    emailId: "rahul@demo.com",
    mobileNumber: "+919876543210",
    firstName: "Rahul",
    lastName: "Sharma",
    uuid: "UUID-001-ABCD",
    status: "Active",
    kycVerified: 2,
    referral_code: "REF001",
    createdAt: "2025-01-10T08:30:00Z",
  },
  {
    _id: "usr_002",
    emailId: "priya@demo.com",
    mobileNumber: "+919887766554",
    firstName: "Priya",
    lastName: "Patel",
    uuid: "UUID-002-EFGH",
    status: "Active",
    kycVerified: 2,
    referral_code: "REF002",
    createdAt: "2025-01-15T10:00:00Z",
  },
  {
    _id: "usr_003",
    emailId: "amit@demo.com",
    mobileNumber: "+919112233445",
    firstName: "Amit",
    lastName: "Verma",
    uuid: "UUID-003-IJKL",
    status: "Inactive",
    kycVerified: 1,
    referral_code: "REF003",
    createdAt: "2025-02-01T14:15:00Z",
  },
  {
    _id: "usr_004",
    emailId: "sneha@demo.com",
    mobileNumber: "+919223344556",
    firstName: "Sneha",
    lastName: "Gupta",
    uuid: "UUID-004-MNOP",
    status: "Active",
    kycVerified: 0,
    referral_code: "REF004",
    createdAt: "2025-02-05T09:45:00Z",
  },
  {
    _id: "usr_005",
    emailId: "vikram@demo.com",
    mobileNumber: "+919334455667",
    firstName: "Vikram",
    lastName: "Singh",
    uuid: "UUID-005-QRST",
    status: "Active",
    kycVerified: 3,
    referral_code: "REF005",
    createdAt: "2025-02-08T11:30:00Z",
  },
];

// Coin List Details – listing applications (projectName, contact, contract, status, etc.)
export const dummyCoinListDetails = [
  {
    _id: "demo_001",
    projectName: "MoonToken",
    emailId: "contact@moontoken.io",
    countryCode: "+1",
    phoneNumber: "5551234567",
    referredBy: "John Doe",
    smartContractAddress: "0x1234567890abcdef1234567890abcdef12345678",
    comments: "Promising DeFi project with strong community",
    createdAt: "2025-11-15T10:30:00.000Z",
    status: "pending",
    ContactName: "Alice Johnson",
    Telegram: "@moontoken_official",
    WhatsappID: "+15551234567",
  },
  {
    _id: "demo_002",
    projectName: "StarDust",
    emailId: "hello@stardust.finance",
    countryCode: "+44",
    phoneNumber: "7700900123",
    referredBy: "Jane Smith",
    smartContractAddress: "0xabcdef1234567890abcdef1234567890abcdef12",
    comments: "NFT gaming token, audit completed",
    createdAt: "2025-11-14T08:00:00.000Z",
    status: "approved",
    ContactName: "Bob Williams",
    Telegram: "@stardust_support",
    WhatsappID: "+447700900123",
  },
  {
    _id: "demo_003",
    projectName: "PepeChain",
    emailId: "team@pepechain.com",
    countryCode: "+91",
    phoneNumber: "9876543210",
    referredBy: "—",
    smartContractAddress: "0x9876543210fedcba9876543210fedcba98765432",
    comments: "Meme token, high volume expected",
    createdAt: "2025-11-13T14:20:00.000Z",
    status: "rejected",
    ContactName: "Charlie Brown",
    Telegram: "@pepechain",
    WhatsappID: "+919876543210",
  },
  {
    _id: "demo_004",
    projectName: "SafeVault",
    emailId: "info@safevault.io",
    countryCode: "+1",
    phoneNumber: "5559876543",
    referredBy: "Alice Johnson",
    smartContractAddress: "0x5555555555555555555555555555555555555555",
    comments: "Yield aggregator, KYC done",
    createdAt: "2025-11-12T09:15:00.000Z",
    status: "pending",
    ContactName: "Diana Prince",
    Telegram: "@safevault_io",
    WhatsappID: "+15559876543",
  },
];

// Trading Fee Report – market trades with order details
export const dummyTrades = [
  { _id: "demo_001", createdAt: "2026-01-15T10:30:00.000Z", time: "15/01/2026, 10:30:00 AM", order_id: "ORD_TR001", user_email: "trader1@example.com", user_mobileNumber: "9876543210", main_currency: "BTC", currency: "USDT", side: "BUY", order_type: "LIMIT", price: 42500.00, quantity: 0.25, fee: 0.000025, tds: 0, counter_user: "BINANCE_LP" },
  { _id: "demo_002", createdAt: "2026-01-16T14:20:00.000Z", time: "16/01/2026, 2:20:00 PM", order_id: "ORD_TR002", user_email: "trader2@example.com", user_mobileNumber: "8765432109", main_currency: "ETH", currency: "USDT", side: "SELL", order_type: "MARKET", price: 2250.00, quantity: 1.5, fee: 0.0015, tds: 0, counter_user: "user_abc123" },
  { _id: "demo_003", createdAt: "2026-01-17T08:45:00.000Z", time: "17/01/2026, 8:45:00 AM", order_id: "ORD_TR003", user_email: "trader3@example.com", user_mobileNumber: "7654321098", main_currency: "BNB", currency: "USDT", side: "BUY", order_type: "LIMIT", price: 310.50, quantity: 5.0, fee: 0.005, tds: 0, counter_user: "BINANCE_LP" },
  { _id: "demo_004", createdAt: "2026-01-18T11:00:00.000Z", time: "18/01/2026, 11:00:00 AM", order_id: "ORD_TR004", user_email: "trader4@example.com", user_mobileNumber: "6543210987", main_currency: "SOL", currency: "USDT", side: "SELL", order_type: "MARKET", price: 98.75, quantity: 20.0, fee: 0.02, tds: 0, counter_user: "user_def456" },
];

// OrderBook – open/order book orders
export const dummyOrders = [
  { _id: "ORD_OB001", createdAt: "2026-01-15T10:30:00.000Z", user_id: "USR_001", user_email: "trader1@example.com", pay_currency: "USDT", ask_currency: "BTC", order_type: "LIMIT", filled: 0.15, price: 42500.0, remaining: 0.10, quantity: 0.25, side: "BUY", status: "PARTIAL" },
  { _id: "ORD_OB002", createdAt: "2026-01-16T14:20:00.000Z", user_id: "USR_002", user_email: "trader2@example.com", pay_currency: "ETH", ask_currency: "USDT", order_type: "MARKET", filled: 2.0, price: 2250.0, remaining: 0, quantity: 2.0, side: "SELL", status: "FILLED" },
  { _id: "ORD_OB003", createdAt: "2026-01-17T08:45:00.000Z", user_id: "USR_003", user_email: "trader3@example.com", pay_currency: "USDT", ask_currency: "BNB", order_type: "LIMIT", filled: 0, price: 310.50, remaining: 5.0, quantity: 5.0, side: "BUY", status: "PENDING" },
  { _id: "ORD_OB004", createdAt: "2026-01-18T11:00:00.000Z", user_id: "USR_004", user_email: "trader4@example.com", pay_currency: "BTC", ask_currency: "USDT", order_type: "LIMIT", filled: 0, price: 43000.0, remaining: 0.1, quantity: 0.1, side: "SELL", status: "CANCELLED" },
];

// All Open Orders
export const dummyOpenOrders = [
  { _id: "OO_001", updatedAt: "2026-01-20T09:15:00.000Z", user_email: "trader1@example.com", user_mobileNumber: "9876543210", ask_currency: "BTC", pay_currency: "USDT", order_type: "LIMIT", filled: 0.05, maker_fee: 0.00005, taker_fee: 0.0001, price: 42500.0, remaining: 0.20, quantity: 0.25, side: "BUY", user_id: "USR_001" },
  { _id: "OO_002", updatedAt: "2026-01-20T10:30:00.000Z", user_email: "trader2@example.com", user_mobileNumber: "8765432109", ask_currency: "USDT", pay_currency: "ETH", order_type: "LIMIT", filled: 0, maker_fee: 0.002, taker_fee: 0.003, price: 2280.0, remaining: 3.0, quantity: 3.0, side: "SELL", user_id: "USR_002" },
  { _id: "OO_003", updatedAt: "2026-01-20T11:45:00.000Z", user_email: "trader3@example.com", user_mobileNumber: "7654321098", ask_currency: "BNB", pay_currency: "USDT", order_type: "LIMIT", filled: 2.0, maker_fee: 0.002, taker_fee: 0.003, price: 315.0, remaining: 8.0, quantity: 10.0, side: "BUY", user_id: "USR_003" },
];

// Deposit (Funds Management)
export const dummyDeposits = [
  { index: 1, createdAt: "2025-12-15T10:30:00Z", user_id: "USR_1001", emailId: "alice@example.com", mobileNumber: "9876543210", chain: "BSC", currency: "USDT", short_name: "USDT", amount: 1500.5, from_address: "0xAb5801a7D398351b8bE11C439e05C5B3259aeC9B", to_address: "0x742d35Cc6634C0532925a3b844Bc9e7595f2bD38", transaction_hash: "0xabc123def456789abc123def456789abc123def456789abc123def456789abcd", status: "SUCCESS" },
  { index: 2, createdAt: "2025-12-14T14:20:00Z", user_id: "USR_1002", emailId: "bob@example.com", mobileNumber: "9876543211", chain: "ETH", currency: "ETH", short_name: "ETH", amount: 2.3456, from_address: "0x1234567890abcdef1234567890abcdef12345678", to_address: "0xabcdef1234567890abcdef1234567890abcdef12", transaction_hash: "0xdef456789abc123def456789abc123def456789abc123def456789abcdef1234", status: "SUCCESS" },
  { index: 3, createdAt: "2025-12-13T08:15:00Z", user_id: "USR_1003", emailId: "carol@example.com", mobileNumber: "9876543212", chain: "TRC20", currency: "USDT", short_name: "USDT", amount: 500.0, from_address: "TXyz1234567890abcdef1234567890abcd", to_address: "TAbcdef1234567890abcdef1234567890ab", transaction_hash: "txhash_demo_003_abcdef1234567890", status: "SUCCESS" },
  { index: 4, createdAt: "2025-12-12T16:45:00Z", user_id: "USR_1004", emailId: "dave@example.com", mobileNumber: "9876543213", chain: "BSC", currency: "BNB", short_name: "BNB", amount: 0.8721, from_address: "0x5678abcdef1234567890abcdef12345678901234", to_address: "0xfedcba0987654321fedcba0987654321fedcba09", transaction_hash: "0x789abc123def456789abc123def456789abc123def456789abc123def456789a", status: "SUCCESS" },
];

// Transfer Transactions
export const dummyTransactions = [
  { _id: "tt_001", createdAt: "2026-01-15T10:30:00.000Z", user_id: "USR_001", chain: "TRC20", currency: "USDT", amount: 5000.0, fee: 1.0, from_address: "TLa2f6VPqDgREjxSH6FeqA1sW7VqyYU81h", to_address: "TNPeeaaFB7K9cmo4uQpcU32zGK8G1NYqeL", transaction_hash: "abc123def456abc123def456abc123def456abc123def456abc123def456abcd", status: "Completed" },
  { _id: "tt_002", createdAt: "2026-01-16T14:20:00.000Z", user_id: "USR_002", chain: "BEP20", currency: "BNB", amount: 2.5, fee: 0.001, from_address: "0x1234567890abcdef1234567890abcdef12345678", to_address: "0xabcdef1234567890abcdef1234567890abcdef12", transaction_hash: "0xfedcba9876543210fedcba9876543210fedcba9876543210fedcba9876543210", status: "Completed" },
  { _id: "tt_003", createdAt: "2026-01-17T08:45:00.000Z", user_id: "USR_003", chain: "ERC20", currency: "ETH", amount: 1.25, fee: 0.005, from_address: "0x9876543210fedcba9876543210fedcba98765432", to_address: "0x1111222233334444555566667777888899990000", transaction_hash: "0x1234abcd5678efgh1234abcd5678efgh1234abcd5678efgh1234abcd5678efgh", status: "Failed" },
  { _id: "tt_004", createdAt: "2026-01-18T11:00:00.000Z", user_id: "USR_004", chain: "TRC20", currency: "USDT", amount: 10000.0, fee: 1.0, from_address: "TNPeeaaFB7K9cmo4uQpcU32zGK8G1NYqeL", to_address: "TLa2f6VPqDgREjxSH6FeqA1sW7VqyYU81h", transaction_hash: "xyz789xyz789xyz789xyz789xyz789xyz789xyz789xyz789xyz789xyz789xyzw", status: "Completed" },
];

// Funds Withdrawal – Pending, Completed, Cancelled
export const dummyWithdrawals = [
  { _id: "demo_p001", user_id: "USR_4001", createdAt: "2025-12-15T10:00:00Z", emailId: "alice@example.com", mobileNumber: "9876540001", chain: "BSC", short_name: "USDT", to_address: "0xAb5801a7D398351b8bE11C439e05C5B3259aeC9B", amount: 500.0, fee: 2.5, status: "PENDING", payment_type: "CRYPTO" },
  { _id: "demo_p002", user_id: "USR_4002", createdAt: "2025-12-14T14:00:00Z", emailId: "bob@example.com", mobileNumber: "9876540002", chain: "ETH", short_name: "ETH", to_address: "0x742d35Cc6634C0532925a3b844Bc9e7595f2bD38", amount: 1.25, fee: 0.005, status: "PENDING", payment_type: "CRYPTO" },
  { _id: "demo_p003", user_id: "USR_4003", createdAt: "2025-12-13T08:00:00Z", emailId: "carol@example.com", mobileNumber: "9876540003", chain: "---", short_name: "INR", to_address: "", amount: 25000, fee: 50, status: "PENDING", payment_type: "FIAT", user_bank: { bank_name: "State Bank of India", account_holder_name: "Carol Smith", account_number: "1234567890", ifsc_code: "SBIN0001234", branch_address: "Main Branch, Mumbai" } },
  { _id: "demo_c001", user_id: "USR_4004", createdAt: "2025-12-12T09:30:00Z", emailId: "dave@example.com", mobileNumber: "9876540004", chain: "TRC20", short_name: "USDT", to_address: "TLa2f6VPqDgREjxSH6FeqA1sW7VqyYU81h", amount: 1000.0, fee: 1.0, status: "COMPLETED", payment_type: "CRYPTO" },
  { _id: "demo_c002", user_id: "USR_4005", createdAt: "2025-12-11T16:00:00Z", emailId: "eve@example.com", mobileNumber: "9876540005", chain: "BEP20", short_name: "BNB", to_address: "0xabcdef1234567890abcdef1234567890abcdef12", amount: 0.5, fee: 0.001, status: "COMPLETED", payment_type: "CRYPTO" },
  { _id: "demo_x001", user_id: "USR_4006", createdAt: "2025-12-10T11:00:00Z", emailId: "frank@example.com", mobileNumber: "9876540006", chain: "ETH", short_name: "ETH", to_address: "0x1111222233334444555566667777888899990000", amount: 0.25, fee: 0.005, status: "CANCELLED", payment_type: "CRYPTO" },
  { _id: "demo_x002", user_id: "USR_4007", createdAt: "2025-12-09T14:20:00Z", emailId: "grace@example.com", mobileNumber: "9876540007", chain: "---", short_name: "INR", to_address: "", amount: 15000, fee: 30, status: "CANCELLED", payment_type: "FIAT", user_bank: { bank_name: "HDFC Bank", account_holder_name: "Grace Lee", account_number: "9876543210", ifsc_code: "HDFC0001234", branch_address: "Delhi Branch" } },
];

// Trading Commission
export const dummyCommissions = [
  { _id: "demo_001", createdAt: "2026-01-15T10:30:00.000Z", short_name: "BTC", fromOrder: "ORD_ABC123", amount: 0.5, percentage: 0.1, fee: 0.0005, fee_type: "MAKER", order_details: { orderId: "ORD_ABC123", ask_currency: "BTC", pay_currency: "USDT", side: "BUY", order_type: "LIMIT", price: 42500.0, quantity: 0.5, status: "FILLED" } },
  { _id: "demo_002", createdAt: "2026-01-16T14:20:00.000Z", short_name: "ETH", fromOrder: "ORD_DEF456", amount: 2.0, percentage: 0.1, fee: 0.002, fee_type: "TAKER", order_details: { orderId: "ORD_DEF456", ask_currency: "USDT", pay_currency: "ETH", side: "SELL", order_type: "MARKET", price: 2250.0, quantity: 2.0, status: "FILLED" } },
  { _id: "demo_003", createdAt: "2026-01-17T08:45:00.000Z", short_name: "BNB", fromOrder: "ORD_GHI789", amount: 10.0, percentage: 0.15, fee: 0.015, fee_type: "MAKER", order_details: { orderId: "ORD_GHI789", ask_currency: "BNB", pay_currency: "USDT", side: "BUY", order_type: "LIMIT", price: 310.5, quantity: 10.0, status: "FILLED" } },
  { _id: "demo_004", createdAt: "2026-01-18T11:00:00.000Z", short_name: "USDT", fromOrder: "ORD_JKL012", amount: 500, percentage: 0.1, fee: 0.5, fee_type: "TAKER", order_details: { orderId: "ORD_JKL012", ask_currency: "USDT", pay_currency: "BTC", side: "SELL", order_type: "MARKET", price: 43000.0, quantity: 0.012, status: "FILLED" } },
];

// Withdrawal Fees
export const dummyFees = [
  { updatedAt: "2025-12-15T10:00:00Z", createdAt: "2025-12-15T10:00:00Z", uuid: "UUID_14001", emailId: "alice@example.com", mobileNumber: "9876540001", short_name: "USDT", fee: 2.5, amount: 500.0 },
  { updatedAt: "2025-12-14T14:00:00Z", createdAt: "2025-12-14T14:00:00Z", uuid: "UUID_14002", emailId: "bob@example.com", mobileNumber: "9876540002", short_name: "ETH", fee: 0.005, amount: 1.25 },
  { updatedAt: "2025-12-13T08:00:00Z", createdAt: "2025-12-13T08:00:00Z", uuid: "UUID_14003", emailId: "carol@example.com", mobileNumber: "9876540003", short_name: "BNB", fee: 0.001, amount: 0.5 },
  { updatedAt: "2025-12-12T16:00:00Z", createdAt: "2025-12-12T16:00:00Z", uuid: "UUID_14004", emailId: "dave@example.com", mobileNumber: "9876540004", short_name: "USDT", fee: 1.0, amount: 200.0 },
];

// Exchange Wallet Management
export const dummyWalletList = [
  { _id: "w_001", userId: "USR_001", emailId: "trader1@example.com", short_name: "USDT", balance: 15230.50, locked_balance: 2500.00, currency_id: "cur_usdt" },
  { _id: "w_002", userId: "USR_002", emailId: "trader2@example.com", short_name: "USDT", balance: 8750.25, locked_balance: 1000.00, currency_id: "cur_usdt" },
  { _id: "w_003", userId: "USR_003", emailId: "trader3@example.com", short_name: "USDT", balance: 42100.00, locked_balance: 5000.00, currency_id: "cur_usdt" },
  { _id: "w_004", userId: "USR_004", emailId: "trader4@example.com", short_name: "USDT", balance: 0, locked_balance: 0, currency_id: "cur_usdt" },
];

export const dummyCoinList = [
  { _id: "c_001", short_name: "BTC", chain: ["ERC20", "BEP20"] },
  { _id: "c_002", short_name: "ETH", chain: ["ERC20"] },
  { _id: "c_003", short_name: "USDT", chain: ["TRC20", "ERC20", "BEP20"] },
  { _id: "c_004", short_name: "BNB", chain: ["BEP20"] },
];

// Launchpad Management – Upcoming, Pending (Live), Ended
export const dummyLaunchpadList = [
  { _id: "lp_001", tokenName: "Alpha Token", tokenSymbol: "ALPHA", category: "Upcoming", startTime: "2026-02-01", endTime: "2026-02-28", totalSupply: "1000000", tokensForSale: "500000", status: "Upcoming" },
  { _id: "lp_002", tokenName: "Beta Coin", tokenSymbol: "BETA", category: "Pending", startTime: "2026-01-15", endTime: "2026-01-31", totalSupply: "2000000", tokensForSale: "1000000", status: "Pending" },
  { _id: "lp_003", tokenName: "Delta Token", tokenSymbol: "DELTA", category: "Pending", startTime: "2026-01-20", endTime: "2026-02-15", totalSupply: "800000", tokensForSale: "400000", status: "Live" },
  { _id: "lp_004", tokenName: "Gamma Token", tokenSymbol: "GAMMA", category: "Ended", startTime: "2025-12-01", endTime: "2025-12-20", totalSupply: "500000", tokensForSale: "250000", status: "Ended" },
];

export const dummySalesTracking = [
  { _id: "st_001", launchpadName: "Alpha Token", tokenSymbol: "ALPHA", sold: "125000", totalForSale: "500000", raised: "62500", participants: 342, date: "2026-01-20" },
  { _id: "st_002", launchpadName: "Beta Coin", tokenSymbol: "BETA", sold: "450000", totalForSale: "1000000", raised: "225000", participants: 1205, date: "2026-01-22" },
];

// Admin Debit / Credit Transactions
export const dummyAdminDebitCredit = [
  { index: 0, createdAt: "2025-12-15T10:00:00Z", user_id: "USR_8001", emailId: "alice@example.com", amount: 500.0, short_name: "USDT", description: "Bonus credit", transaction_type: "CREDIT", from_admin: "admin@exchange.com" },
  { index: 1, createdAt: "2025-12-14T14:00:00Z", user_id: "USR_8002", emailId: "bob@example.com", amount: 150.0, short_name: "USDT", description: "Penalty debit", transaction_type: "DEBIT", from_admin: "admin@exchange.com" },
  { index: 2, createdAt: "2025-12-13T08:00:00Z", user_id: "USR_8003", emailId: "carol@example.com", amount: 1.25, short_name: "ETH", description: "Referral bonus", transaction_type: "CREDIT", from_admin: "superadmin@exchange.com" },
  { index: 3, createdAt: "2025-12-12T16:00:00Z", user_id: "USR_8004", emailId: "dave@example.com", amount: 2500.0, short_name: "INR", description: "Manual adjustment", transaction_type: "CREDIT", from_admin: "admin@exchange.com" },
];

// Announcement Management
export const dummyAnnouncements = [
  { _id: "ann_001", category: "General", title: "Platform Maintenance", description: "Scheduled maintenance on Dec 20, 2025.", createdAt: "2025-12-10T09:00:00Z", status: "Active" },
  { _id: "ann_002", category: "Trading", title: "New Pairs Listed", description: "BTC/USDT and ETH/USDT pairs are now available.", createdAt: "2025-12-11T14:00:00Z", status: "Active" },
  { _id: "ann_003", category: "Security", title: "2FA Recommended", description: "Enable two-factor authentication for your account.", createdAt: "2025-12-12T10:00:00Z", status: "Active" },
  { _id: "ann_004", category: "General", title: "Old Event Notice", description: "This announcement has been archived.", createdAt: "2025-11-01T08:00:00Z", status: "Inactive" },
];

// P2P Orders Management
export const dummyP2POrders = [
  { sr: 1, order_id: "ord_demo", ad_uid: "AD-10001", side: "BUY", fiat: "USD", quote: "BTC", fiat_amount: 5000, crypto_amount: 0.1176, price: 42500, buyer: "John Doe", status: "Released" },
  { sr: 2, order_id: "ord_2001", ad_uid: "AD-10002", side: "SELL", fiat: "INR", quote: "ETH", fiat_amount: 100000, crypto_amount: 0.54, price: 185000, buyer: "Raj Patel", status: "Pending" },
  { sr: 3, order_id: "ord_2002", ad_uid: "AD-10003", side: "BUY", fiat: "EUR", quote: "USDT", fiat_amount: 920, crypto_amount: 1000, price: 0.92, buyer: "Marco Rossi", status: "Disputes" },
  { sr: 4, order_id: "ord_2003", ad_uid: "AD-10004", side: "SELL", fiat: "USD", quote: "BTC", fiat_amount: 2125, crypto_amount: 0.05, price: 42500, buyer: "Tom Wilson", status: "Released" },
];

// P2P Ads Management (structure matches API: adUid, fiatCurrency, qouteCurrency, fixedPrice, remainingVolume, isOnline, userInfo, activeOrders, totalOrders)
export const dummyP2PAds = [
  { _id: "demo_001", adUid: "AD-10001", side: "BUY", fiatCurrency: "USD", qouteCurrency: "BTC", fixedPrice: 42500, volume: 2.5, remainingVolume: 1.8, status: "OPEN", isOnline: true, activeOrders: 2, totalOrders: 5, userInfo: { firstName: "John", lastName: "Doe", emailId: "john@example.com" }, createdAt: "2025-09-10T08:00:00Z" },
  { _id: "demo_002", adUid: "AD-10002", side: "SELL", fiatCurrency: "INR", qouteCurrency: "ETH", fixedPrice: 185000, volume: 10, remainingVolume: 10, status: "OPEN", isOnline: false, activeOrders: 0, totalOrders: 3, userInfo: { firstName: "Priya", lastName: "Sharma", emailId: "priya@example.com" }, createdAt: "2025-08-22T12:30:00Z" },
  { _id: "demo_003", adUid: "AD-10003", side: "BUY", fiatCurrency: "EUR", qouteCurrency: "USDT", fixedPrice: 0.92, volume: 5000, remainingVolume: 0, status: "CLOSED", isOnline: false, activeOrders: 0, totalOrders: 8, userInfo: { firstName: "Marco", lastName: "Rossi", emailId: "marco@example.com" }, createdAt: "2025-07-15T16:45:00Z" },
  { _id: "demo_004", adUid: "AD-10004", side: "SELL", fiatCurrency: "USD", qouteCurrency: "BTC", fixedPrice: 43000, volume: 1.0, remainingVolume: 0.6, status: "PARTIALLY_FILLED", isOnline: true, activeOrders: 1, totalOrders: 2, userInfo: { firstName: "Alice", lastName: "Chen", emailId: "alice@example.com" }, createdAt: "2025-09-01T10:00:00Z" },
];

// P2P Ad Details (extra fields + orders per ad)
export const dummyP2PAdDetails = {
  demo_001: {
    minLimit: 100,
    maxLimit: 10000,
    ownerPhone: "+1234567890",
    stats: { totalOrders: 12, releasedOrders: 8, totalCryptoTraded: 1.25, totalFiatTraded: 53125 },
    orders: [
      { sr: 1, orderId: "ord_demo", buyer: "Alice Chen", seller: "John Doe", fiatAmount: 5000, cryptoAmount: 0.1176, status: "RELEASED", createdAt: "2025-09-10T10:00:00Z" },
      { sr: 2, orderId: "ord_demo", buyer: "Raj Patel", seller: "John Doe", fiatAmount: 2000, cryptoAmount: 0.047, status: "PAID", createdAt: "2025-09-11T20:00:00Z" },
      { sr: 3, orderId: "ord_demo", buyer: "Tom Wilson", seller: "John Doe", fiatAmount: 1500, cryptoAmount: 0.035, status: "PENDING_PAYMENT", createdAt: "2025-09-12T14:45:00Z" },
    ],
  },
  demo_002: { minLimit: 500, maxLimit: 50000, ownerPhone: "+919876543210", stats: { totalOrders: 3, releasedOrders: 2, totalCryptoTraded: 0.5, totalFiatTraded: 92500 }, orders: [] },
  demo_003: { minLimit: 100, maxLimit: 10000, ownerPhone: "+393331234567", stats: { totalOrders: 8, releasedOrders: 8, totalCryptoTraded: 5000, totalFiatTraded: 4600 }, orders: [] },
  demo_004: { minLimit: 200, maxLimit: 5000, ownerPhone: "+1122334455", stats: { totalOrders: 2, releasedOrders: 1, totalCryptoTraded: 0.4, totalFiatTraded: 17200 }, orders: [] },
};

// P2P Dispute Management (adInfo, buyerInfo, sellerInfo, disputeBy, adminDisputeStatus, etc.)
export const dummyP2PDisputes = [
  { _id: "disp_demo_001", adInfo: { adUid: "AD-10001", side: "BUY", fiatCurrency: "USD", qouteCurrency: "BTC" }, fiatAmount: 5000, cryptoAmount: 0.1176, buyerInfo: { firstName: "John", lastName: "Doe", emailId: "john@example.com" }, sellerInfo: { firstName: "Alice", lastName: "Chen", emailId: "alice@example.com" }, disputeBy: "BUYER", disputeReason: "Payment sent but seller not releasing crypto", disputeAt: "2025-09-12T12:00:00Z", adminDisputeStatus: "PENDING", adminDisputeAction: null, adminResolvedBy: null, adminResolvedAt: null, isDisputed: true, createdAt: "2025-09-10T08:00:00Z" },
  { _id: "disp_demo_002", adInfo: { adUid: "AD-10002", side: "SELL", fiatCurrency: "INR", qouteCurrency: "ETH" }, fiatAmount: 100000, cryptoAmount: 0.54, buyerInfo: { firstName: "Raj", lastName: "Patel", emailId: "raj@example.com" }, sellerInfo: { firstName: "Priya", lastName: "Sharma", emailId: "priya@example.com" }, disputeBy: "SELLER", disputeReason: "Buyer claims payment but no proof", disputeAt: "2025-09-11T15:00:00Z", adminDisputeStatus: "RESOLVED", adminDisputeAction: "RELEASE_TO_BUYER", adminResolvedBy: { first_name: "Admin", last_name: "User" }, adminResolvedAt: "2025-09-12T10:00:00Z", isDisputed: true, createdAt: "2025-09-08T14:30:00Z" },
  { _id: "disp_demo_003", adInfo: { adUid: "AD-10003", side: "BUY", fiatCurrency: "EUR", qouteCurrency: "USDT" }, fiatAmount: 920, cryptoAmount: 1000, buyerInfo: { firstName: "Marco", lastName: "Rossi", emailId: "marco@example.com" }, sellerInfo: { firstName: "Lisa", lastName: "Mueller", emailId: "lisa@example.com" }, disputeBy: "BUYER", disputeReason: "Wrong amount received", disputeAt: "2025-09-09T09:30:00Z", adminDisputeStatus: "PENDING", adminDisputeAction: null, adminResolvedBy: null, adminResolvedAt: null, isDisputed: true, createdAt: "2025-09-07T11:00:00Z" },
];

// Dispute Details - chat messages per dispute
export const dummyDisputeChats = {
  disp_demo_001: [
    { from: "BUYER", emailId: "john@example.com", sentAt: "2025-09-12T10:20:00Z", content: "I have sent the payment via bank transfer. Please release the crypto." },
    { from: "SELLER", emailId: "alice@example.com", sentAt: "2025-09-12T10:35:00Z", content: "I haven't received any payment yet. Please share the transaction receipt." },
    { from: "BUYER", emailId: "john@example.com", sentAt: "2025-09-12T11:00:00Z", content: "Here is my payment confirmation screenshot." },
  ],
  disp_demo_002: [
    { from: "SELLER", emailId: "priya@example.com", sentAt: "2025-09-11T15:30:00Z", content: "Buyer has not provided payment proof." },
    { from: "BUYER", emailId: "raj@example.com", sentAt: "2025-09-11T16:00:00Z", content: "I have transferred the amount. Ref number: TXN123." },
  ],
  disp_demo_003: [
    { from: "BUYER", emailId: "marco@example.com", sentAt: "2025-09-09T09:45:00Z", content: "Received amount is less than agreed. Please check." },
  ],
};

// P2P Fiat Currency Management
export const dummyP2PFiatCurrencies = [
  { _id: "fiat_001", currencyName: "US Dollar", shortName: "USD", status: "ACTIVE", createdAt: "2025-08-15T10:00:00Z" },
  { _id: "fiat_002", currencyName: "Indian Rupee", shortName: "INR", status: "ACTIVE", createdAt: "2025-07-20T12:00:00Z" },
  { _id: "fiat_003", currencyName: "Euro", shortName: "EUR", status: "INACTIVE", createdAt: "2025-06-10T09:00:00Z" },
  { _id: "fiat_004", currencyName: "British Pound", shortName: "GBP", status: "ACTIVE", createdAt: "2025-05-05T14:00:00Z" },
];

// P2P User Payment Methods
export const dummyP2PUserPaymentMethods = [
  { _id: "pm_001", userEmail: "john@example.com", userName: "John Doe", paymentType: "Bank Transfer", accountDetails: "HDFC ****4521", fiatCurrency: "INR", status: "ACTIVE", createdAt: "2025-08-10T09:00:00Z" },
  { _id: "pm_002", userEmail: "priya@example.com", userName: "Priya Sharma", paymentType: "UPI", accountDetails: "priya@paytm", fiatCurrency: "INR", status: "ACTIVE", createdAt: "2025-07-22T14:00:00Z" },
  { _id: "pm_003", userEmail: "alice@example.com", userName: "Alice Chen", paymentType: "Bank Transfer", accountDetails: "ICICI ****7890", fiatCurrency: "USD", status: "INACTIVE", createdAt: "2025-06-15T11:00:00Z" },
  { _id: "pm_004", userEmail: "raj@example.com", userName: "Raj Patel", paymentType: "UPI", accountDetails: "raj.patel@ybl", fiatCurrency: "INR", status: "ACTIVE", createdAt: "2025-09-01T08:30:00Z" },
];

// Notification Management (isActive for status)
export const dummyNotifications = [
  { _id: "notif_001", createdAt: "2026-01-15T10:30:00.000Z", title: "System Maintenance", message: "Scheduled maintenance on Jan 20th from 2:00 AM to 4:00 AM UTC.", isActive: true },
  { _id: "notif_002", createdAt: "2026-01-10T14:20:00.000Z", title: "New Trading Pair", message: "SOL/USDT trading pair is now available.", isActive: true },
  { _id: "notif_003", createdAt: "2026-01-05T08:45:00.000Z", title: "KYC Update Required", message: "Please update your KYC documents before Feb 1st.", isActive: false },
  { _id: "notif_004", createdAt: "2025-12-20T16:00:00.000Z", title: "Holiday Trading Hours", message: "Trading hours will be adjusted during the holiday season.", isActive: true },
];

// User suggestions for notification "Select User" (search)
export const dummyNotificationUserSuggestions = [
  { _id: "usr_001", firstName: "John", lastName: "Doe", emailId: "john@example.com" },
  { _id: "usr_002", firstName: "Jane", lastName: "Smith", emailId: "jane@example.com" },
  { _id: "usr_003", firstName: "Priya", lastName: "Sharma", emailId: "priya@example.com" },
  { _id: "usr_004", firstName: "Raj", lastName: "Patel", emailId: "raj@example.com" },
];

// Support Management
export const dummySupportTickets = [
  { _id: "tkt_001", userId: "user_001", emailId: "john@example.com", subject: "Unable to withdraw funds from my account", description: "I have been trying to withdraw my BTC but the transaction keeps failing with an error.", status: "Open", seen: 0, issueImage: null, createdAt: "2025-09-12T10:00:00Z" },
  { _id: "tkt_002", userId: "user_002", emailId: "priya@example.com", subject: "KYC verification pending for too long", description: "My KYC has been pending for over 2 weeks. Please expedite.", status: "Open", seen: 1, issueImage: null, createdAt: "2025-09-11T14:30:00Z" },
  { _id: "tkt_003", userId: "user_003", emailId: "marco@example.com", subject: "Deposit not credited", description: "I deposited 500 USDT 3 days ago but it has not been credited to my account yet. Transaction hash: 0xabc123...", status: "Resolved", seen: 1, issueImage: null, createdAt: "2025-09-08T09:15:00Z" },
  { _id: "tkt_004", userId: "user_004", emailId: "alice@example.com", subject: "Account locked after failed login attempts", description: "My account got locked after entering wrong password. Need help unlocking.", status: "Closed", seen: 1, issueImage: null, createdAt: "2025-09-05T16:45:00Z" },
];

// Support Message (chat) per ticket
export const dummySupportChatMessages = {
  tkt_001: [
    { from: "user", text: "Hi, I am having trouble withdrawing my BTC. The transaction keeps failing.", sentAt: "2025-09-12T10:05:00Z" },
    { from: "support", text: "Hello! Thank you for reaching out. Let me check your account. Can you provide the transaction ID?", sentAt: "2025-09-12T10:10:00Z" },
    { from: "user", text: "Sure, the transaction ID is TXN-20250912-001.", sentAt: "2025-09-12T10:15:00Z" },
  ],
  tkt_002: [
    { from: "user", text: "My KYC has been pending for over 2 weeks. When can I get it approved?", sentAt: "2025-09-11T14:35:00Z" },
    { from: "support", text: "We have escalated your KYC. You should receive an update within 24-48 hours.", sentAt: "2025-09-11T15:00:00Z" },
  ],
  tkt_003: [],
  tkt_004: [],
};

// Update APK – current live version (version display + upload)
export const currentApkVersion = {
  version: "2.1.0",
  uploadedAt: "2025-02-10",
  forceUpdate: false,
};
